import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, Provider, inject } from '@angular/core';
import { HandleErrorService } from 'app/core/error/handle-error.service';
import { globalSuccessInterceptor } from './global-success.interceptor';

export const provideGlobalSuccess = (): Array<Provider | EnvironmentProviders> => {
  return [
    provideHttpClient(withInterceptors([globalSuccessInterceptor])),
    {
      provide: HTTP_INTERCEPTORS,
      useValue: () => inject(HandleErrorService),
      multi: true
    }
  ];
};
